var Marionette = require('backbone.marionette');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var CommonUtils = require('../../utils/common-utils.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var utils = new CommonUtils();

var DocumentPatientForm = Marionette.View.extend({
    template: require('../../templates/documents/document-patient-form.html'),

    regions: {
        patientSelect: '#patient-select'
    },

    ui: {
        container: '#patients-select',
        saveBtn: '#save',
        clickable: '.clickable'
    },

    events: {
        'click @ui.saveBtn': 'save',
        'click @ui.clickable': 'remove'
    },

    childViewEvents: {
        'suggestor:selected:patient': 'onPatientSelected'
    },

    templateContext: function () {
        var that = this;
        var documentPatientRelation = _.find(that.model.get('relations'), function (item) {
            return item.parentId == that.model.get('id')
                && item.systemRelationType == 'DOCUMENT_PATIENT'
                && item.child.id == that.model.get('object').patientId;
        });
        var patient = documentPatientRelation && documentPatientRelation.child && documentPatientRelation.child.object ? {
            id: documentPatientRelation.child.id,
            name: utils.formatPerson(documentPatientRelation.child.object)
        } : undefined;
        return {
            canEdit: function() { return that.canEdit(); },
            patient: patient,
            buttonText: patient ? 'Replace patient' : 'Add patient'
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'save', 'remove');
        this.model = options.model;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;
        this.ui.saveBtn.attr('disabled', true);
        that.patientsSelectView = new RemoteSuggesterView({
            inputId: 'DOCUMENT_PATIENT',
            maxNumberOfElements: 100,
            url: '/api/dbo/preview?page-size=' + 100
            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.isPatient && item.object.mergeable === false;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select patient to add or replace",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'patient'
        });

        that.showChildView('patientSelect', that.patientsSelectView);
    },

    save: function () {
        var that = this;
        var patientId = that.selectedPatientId;
        if (!patientId)
            return;

        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/document/' + that.model.get('id') + '/patient/' + patientId,
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.triggerMethod('patient:added:to:doc', response);
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    remove: function(event) {
        var that = this;

        that.utils.showSpinner();
        $.ajax({
            type: "DELETE",
            url: '/api/document/' + that.model.get('id') + '/patient/' + event.target.id,
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.triggerMethod('patient:added:to:doc', response);
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    onPatientSelected: function(patientId) {
        this.selectedPatientId = patientId;
        if (_.isUndefined(patientId))
            this.ui.saveBtn.attr('disabled', true);
        else
            this.ui.saveBtn.removeAttr('disabled');
    }

});

module.exports = DocumentPatientForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-patient-form.js
// module id = 414
// module chunks = 0